import React from 'react'
import { Redirect, withRouter } from 'react-router-dom'
import Header from '../containers/HeaderContainer'

class Dashboard extends React.Component {
    state = {
        busy: false,
        checkingUser: true,
        searchTerm: ''
    }

    componentDidMount() {
        if (!this.props.user) {
            this.setState({ checkingUser: true }, () => {
                this.props.checkUserSession(() => {
                    this.setState({ checkingUser: false })
                    this._fetchClients()
                })
            })
        } else {
            this.setState({ checkingUser: false }, () => {
                this._fetchClients()
            })
        }
    }

    _fetchClients() {
        this.setState({ busy: true }, () => {
            this.props.fetchClients(() => {
                this.setState({ busy: false })
            })
        })
    }

    _cardStat(label, value) {
        return (
            <div>
                <div className="text-[11px] font-semibold uppercase tracking-[0.24em] text-slate-400 dark:text-slate-500">{label}</div>
                <div className="mt-1 text-sm font-semibold text-slate-700 dark:text-slate-200">{value}</div>
            </div>
        )
    }

    render() {
        if (this.state.checkingUser || this.state.busy) {
            return <div className="px-4 py-5 text-center">Loading clients...</div>
        }

        if (!this.props.user) {
            return <Redirect to='/' />
        }

        const clients = (this.props.clients || [])
            .slice()
            .sort((a, b) => String(a.name || '').localeCompare(String(b.name || '')))
            .filter((client) => String(client.name || '').toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) > -1)

        return (
            <div className="min-h-screen lg:flex">
                <Header />
                <main className="min-w-0 flex-1 px-4 py-4 sm:px-6 lg:px-10 lg:py-8">
                    <div className="mx-auto max-w-7xl">
                        <div className="rounded-[28px] border border-slate-200/70 bg-white/80 p-6 shadow-soft backdrop-blur dark:border-slate-800 dark:bg-slate-950/70">
                            <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
                                <div className="max-w-3xl">
                                    <div className="text-xs font-semibold uppercase tracking-[0.28em] text-sky-600 dark:text-sky-300">Clients</div>
                                    <h1 className="mt-3 text-3xl font-extrabold tracking-tight text-slate-900 dark:text-white sm:text-4xl">Client workspace</h1>
                                </div>
                                <div className="flex flex-wrap gap-3">
                                    <a
                                        href="/clients/new"
                                        className="inline-flex items-center justify-center rounded-2xl px-5 py-3 text-sm font-semibold text-slate-950 no-underline shadow-lg transition hover:-translate-y-0.5"
                                        style={{ background: '#1cd997', boxShadow: '0 14px 32px rgba(28, 217, 151, 0.28)' }}
                                    >
                                        Create client
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="mt-6 overflow-hidden rounded-[28px] border border-slate-200/70 bg-white/80 shadow-soft backdrop-blur dark:border-slate-800 dark:bg-slate-950/70">
                            <div className="border-b border-slate-200/70 px-6 py-4 dark:border-slate-800">
                                <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                                    <div>
                                        <h2 className="text-base font-semibold text-slate-900 dark:text-white">All clients</h2>
                                        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">{clients.length} client records loaded</p>
                                    </div>
                                    <div className="w-full lg:w-80">
                                        <input
                                            className="admin-input block w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm outline-none transition placeholder:text-slate-500 focus:border-sky-500 focus:ring-2 focus:ring-sky-500/20 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:placeholder:text-slate-400"
                                            type="search"
                                            placeholder="Search clients by name"
                                            value={this.state.searchTerm}
                                            onChange={(e) => this.setState({ searchTerm: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="divide-y divide-slate-200/70 dark:divide-slate-800">
                                {clients.map((client, index) => (
                                    <div key={client.PK} className={'px-6 py-3 transition hover:bg-slate-100/90 dark:hover:bg-slate-900/70 ' + (index % 2 === 1 ? 'bg-slate-50/95 dark:bg-slate-900/55' : 'bg-white/95 dark:bg-slate-950/70')}>
                                        <div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
                                            <div className="min-w-0 flex items-start gap-4">
                                                <div className="flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-xl border border-slate-200 bg-slate-50 dark:border-slate-800 dark:bg-slate-900">
                                                    {client.styles && client.styles.logo ?
                                                        <img src={client.styles.logo} alt={client.name} className="h-full w-full object-contain p-1.5" />
                                                        :
                                                        <span className="text-lg font-extrabold text-slate-600 dark:text-slate-300">{client.name ? client.name.charAt(0) : 'C'}</span>
                                                    }
                                                </div>
                                                <div className="min-w-0 flex-1">
                                                    <div className="flex flex-wrap items-center gap-3">
                                                        <a href={'/clients/' + client.PK} className="truncate text-base font-semibold text-slate-900 no-underline hover:text-sky-600 dark:text-white dark:hover:text-sky-300">
                                                            {client.name}
                                                        </a>
                                                        <span className="inline-flex items-center rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-slate-500 dark:bg-slate-800 dark:text-slate-300">
                                                            {client.stub}
                                                        </span>
                                                    </div>
                                                    <p className="mt-0.5 truncate text-sm text-slate-500 dark:text-slate-400">{client.charity || 'No charity name set yet'}</p>
                                                    <div className="mt-3 grid grid-cols-2 gap-x-6 gap-y-2 md:grid-cols-3">
                                                        {this._cardStat('Current event', client.currentEvent || 'None')}
                                                        {this._cardStat('Events', client.eventCount || 0)}
                                                        {this._cardStat('Default max', '$' + Number(client.defaultMaxPrize || 0).toFixed(0))}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="flex shrink-0 flex-wrap items-center gap-2 xl:flex-nowrap xl:justify-end">
                                                <a
                                                    href={'/clients/' + client.PK}
                                                    className="inline-flex min-w-[118px] items-center justify-center rounded-2xl px-3 py-2 text-xs font-semibold text-slate-950 no-underline transition hover:brightness-95"
                                                    style={{ background: '#1cd997' }}
                                                >
                                                    Open client
                                                </a>
                                                <a
                                                    href={'/clients/' + client.PK + '?tab=events'}
                                                    className="inline-flex min-w-[96px] items-center justify-center rounded-2xl border border-slate-300 px-3 py-2 text-xs font-semibold text-slate-700 no-underline transition hover:border-slate-400 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-900"
                                                >
                                                    Events
                                                </a>
                                                <a
                                                    href={'https://s50.events/' + client.stub}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="inline-flex min-w-[120px] items-center justify-center rounded-2xl border border-slate-300 px-3 py-2 text-xs font-semibold text-slate-700 no-underline transition hover:border-slate-400 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-900"
                                                >
                                                    Public page
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {clients.length === 0 ?
                                    <div className="px-6 py-14 text-center text-sm text-slate-500 dark:text-slate-400">
                                        No clients matched that search.
                                    </div>
                                    : null}
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        )
    }
}

export default withRouter(Dashboard)
